import Vue from "vue";
import Vuex from "vuex";
import * as notification from "@/store/modules/notification";
import * as drawer from "@/store/modules/drawer";
import * as user from "@/store/modules/user";
import * as text from "@/store/modules/text";
import * as offer from "@/store/modules/offer";
import * as appointment from "@/store/modules/appointments";
import * as reservation from "@/store/modules/reservations";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    notification,
    drawer,
    user,
    text,
    offer,
    appointment,
    reservation
  }
});
